import './DressCode.scss';

const ExternalLinkIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
    <polyline points="15,3 21,3 21,9"/>
    <line x1="10" y1="14" x2="21" y2="3"/>
  </svg>
);

const DressCode = () => {
  const colors = [
    { color: '#FFF4EC', name: 'Кремовый' },
    { color: '#F7DCC6', name: 'Горчичный' },
    { color: '#B59E90', name: 'Охра' },
    { color: '#9B8273', name: 'Коричневый' },
    { color: '#614B46', name: 'Графит' }
  ];

  return (
     <section className="dresscode">
        <h2 className="dresscode__title">Дресс-код</h2>
        <p className="dresscode__description">
           Для нас самое главное - ваше присутствие!
        </p>
        <p className="dresscode__description">
           Однако, мы будем очень благодарны, если вы поддержите цветовую гамму нашей свадьбы: от бежевого до черного.
        </p>

        <div className="dresscode__palette">
           {colors.map((item, index) => (
              <div
                 key={index}
                 className="dresscode__color"
                 style={{backgroundColor: item.color}}
                 title={item.name}
              />
           ))}
        </div>

        <p className="dresscode__note">
           Дорогие гости, при выборе наряда, пожалуйста, воздержитесь от белого цвета, как основного в наряде. Ведь белый - цвет невесты.
        </p>
     </section>
  );
};

export default DressCode;
